import { authActions } from '../../store/authStore';
import { client } from '../services/apollo';
import { EXCHANGE_CROSS_SITE_SSO_CODE } from '../services/authService/queries';
import { getCurrentSiteHost } from './siteHost';

let crossSiteSsoExchangePromise: Promise<boolean> = Promise.resolve(false);

export function getCrossSiteSsoExchangePromise(): Promise<boolean> {
  return crossSiteSsoExchangePromise;
}

function removeSsoCodeFromUrl(): void {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location.href);
  url.searchParams.delete('sso_code');
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
}

export async function exchangeCrossSiteSsoCodeFromUrl(): Promise<boolean> {
  if (typeof window === 'undefined') return false;

  const params = new URLSearchParams(window.location.search);
  const ssoCode = params.get('sso_code');
  if (!ssoCode) {
    crossSiteSsoExchangePromise = Promise.resolve(false);
    return false;
  }

  crossSiteSsoExchangePromise = (async () => {
    const { data } = await client.mutate({
      mutation: EXCHANGE_CROSS_SITE_SSO_CODE,
      variables: {
        input: {
          code: ssoCode,
          targetHost: getCurrentSiteHost(),
        },
      },
    });

    const auth = data?.exchangeCrossSiteSsoCode;
    if (!auth) return false;

    authActions.setAuth(
      {
        accessToken: auth.accessToken,
        idToken: auth.idToken,
        refreshToken: auth.refreshToken,
      },
      auth.user,
      'CROSS_SITE_SSO',
    );
    return true;
  })();

  try {
    return await crossSiteSsoExchangePromise;
  } catch (error) {
    console.warn('Failed to exchange cross-site SSO code.', error);
    return false;
  } finally {
    removeSsoCodeFromUrl();
  }
}
